(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.natdsIcons = {}));
})(this, (function (exports) { 'use strict';

	var icons = {
		"filled-action-add": "%uEA01",
		"filled-action-cancel": "%uEA02",
		"filled-action-check": "%uEA03",
		"filled-action-clock": "%uEAEC",
		"filled-action-delete": "%uEA04",
		"filled-action-dislike": "%uEB0F",
		"filled-action-increase": "%uEB27",
		"filled-action-love": "%uEA05",
		"filled-action-newrequest": "%uEA06",
		"filled-action-privacy": "%uEB19",
		"filled-action-rating": "%uEA07",
		"filled-action-register": "%uEB1A",
		"filled-action-request": "%uEAED",
		"filled-action-subtract": "%uEA08",
		"filled-brand-avonshorthand": "%uEAEE",
		"filled-brand-facebook": "%uEA09",
		"filled-brand-google": "%uEA0A",
		"filled-brand-instagram": "%uEA0B",
		"filled-brand-linkedin": "%uEA0C",
		"filled-brand-messenger": "%uEB28",
		"filled-brand-naturarosacea": "%uEA0D",
		"filled-brand-pinterest": "%uEA0E",
		"filled-brand-spotify": "%uEA0F",
		"filled-brand-thebodyshop": "%uEB10",
		"filled-brand-twitter": "%uEA10",
		"filled-brand-whatsapp": "%uEA11",
		"filled-brand-youtube": "%uEA12",
		"filled-communication-noconnection": "%uEB17",
		"filled-content-channel": "%uEA13",
		"filled-content-divulgation": "%uEA14",
		"filled-content-quote": "%uEA15",
		"filled-content-violence": "%uEB1B",
		"filled-content-wifi": "%uEB14",
		"filled-content-world": "%uEB15",
		"filled-default-mockup": "%uEA16",
		"filled-finance-charging": "%uEA17",
		"filled-finance-invoice": "%uEAEF",
		"filled-finance-money": "%uEAF0",
		"filled-finance-paymentlink": "%uEA18",
		"filled-finance-paymentnotapproved": "%uEAF1",
		"filled-finance-pix": "%uEB2B",
		"filled-media-pause": "%uEA19",
		"filled-media-play": "%uEA1A",
		"filled-media-stop": "%uEA1B",
		"filled-navigation-arrowbottom": "%uEA1C",
		"filled-navigation-arrowleft": "%uEA1D",
		"filled-navigation-arrowright": "%uEA1E",
		"filled-navigation-arrowtop": "%uEA1F",
		"filled-navigation-directionleft": "%uEA20",
		"filled-navigation-directionright": "%uEA21",
		"filled-navigation-directiontbottom": "%uEA22",
		"filled-navigation-directiontop": "%uEA23",
		"filled-navigation-home": "%uEAF2",
		"filled-navigation-menu": "%uEA24",
		"filled-navigation-more": "%uEA25",
		"filled-navigation-setbottom": "%uEA26",
		"filled-navigation-setleft": "%uEA27",
		"filled-navigation-setright": "%uEA28",
		"filled-navigation-settop": "%uEA29",
		"filled-place-local": "%uEB11",
		"filled-place-truck": "%uEAF3",
		"filled-product-brandsproduct": "%uEA2A",
		"filled-product-fashion": "%uEB1C",
		"filled-social-myprofile": "%uEA2B",
		"filled-toggle-indeterminatecheckbox": "%uEA2C",
		"outlined-action-add": "%uEA2D",
		"outlined-action-addproduct": "%uEA2E",
		"outlined-action-attachment": "%uEA2F",
		"outlined-action-autofilter": "%uEA30",
		"outlined-action-calendar": "%uEA31",
		"outlined-action-camerachange": "%uEA32",
		"outlined-action-cancel": "%uEA33",
		"outlined-action-change": "%uEA34",
		"outlined-action-check": "%uEA35",
		"outlined-action-clock": "%uEA36",
		"outlined-action-closedbox": "%uEA37",
		"outlined-action-copy": "%uEA38",
		"outlined-action-copylink": "%uEA39",
		"outlined-action-cycle": "%uEA3A",
		"outlined-action-delete": "%uEA3B",
		"outlined-action-dislike": "%uEB12",
		"outlined-action-done": "%uEA3C",
		"outlined-action-download": "%uEA3D",
		"outlined-action-edit": "%uEA3E",
		"outlined-action-favorite": "%uEA3F",
		"outlined-action-filter": "%uEA40",
		"outlined-action-frame": "%uEAE4",
		"outlined-action-gridsquare": "%uEA41",
		"outlined-action-help": "%uEA42",
		"outlined-action-history": "%uEA43",
		"outlined-action-increase": "%uEB29",
		"outlined-action-lightoff": "%uEA44",
		"outlined-action-lighton": "%uEA45",
		"outlined-action-like": "%uEA46",
		"outlined-action-list": "%uEA47",
		"outlined-action-love": "%uEA48",
		"outlined-action-mic": "%uEA49",
		"outlined-action-micrec": "%uEA4A",
		"outlined-action-newregister": "%uEA4B",
		"outlined-action-newrequest": "%uEA4C",
		"outlined-action-order": "%uEA4D",
		"outlined-action-phone": "%uEA4E",
		"outlined-action-print": "%uEA4F",
		"outlined-action-privacy": "%uEB1D",
		"outlined-action-qr": "%uEA50",
		"outlined-action-rating": "%uEA51",
		"outlined-action-recycle": "%uEA52",
		"outlined-action-register": "%uEB1E",
		"outlined-action-request": "%uEA53",
		"outlined-action-requestspecial": "%uEADE",
		"outlined-action-runningclock": "%uEA54",
		"outlined-action-save": "%uEA55",
		"outlined-action-schedule": "%uEA56",
		"outlined-action-search": "%uEA57",
		"outlined-action-selectedalllines": "%uEA58",
		"outlined-action-send": "%uEA59",
		"outlined-action-settings": "%uEA5A",
		"outlined-action-share": "%uEA5B",
		"outlined-action-shareios": "%uEA5C",
		"outlined-action-subtract": "%uEA5D",
		"outlined-action-text": "%uEA5E",
		"outlined-action-update": "%uEA5F",
		"outlined-action-upload": "%uEA60",
		"outlined-action-visibility": "%uEA61",
		"outlined-action-visibilityoff": "%uEA62",
		"outlined-alert-cancel": "%uEA63",
		"outlined-alert-check": "%uEA64",
		"outlined-alert-empty": "%uEA65",
		"outlined-alert-indeterminate": "%uEA66",
		"outlined-alert-info": "%uEA67",
		"outlined-alert-notification": "%uEA68",
		"outlined-alert-notificationsbadge": "%uEAE6",
		"outlined-alert-warning": "%uEA69",
		"outlined-avon-desenvolve": "%uEB1F",
		"outlined-brand-avondesenvolve": "%uEB22",
		"outlined-brand-messenger": "%uEB2A",
		"outlined-brand-thebodyshop": "%uEB13",
		"outlined-communication-chat": "%uEA6A",
		"outlined-communication-email": "%uEA6B",
		"outlined-communication-help": "%uEA6C",
		"outlined-communication-message": "%uEA6D",
		"outlined-communication-noconnection": "%uEB18",
		"outlined-communication-occurrence": "%uEA6E",
		"outlined-communication-phoneringing": "%uEA6F",
		"outlined-communication-readEmail": "%uEA70",
		"outlined-communication-signal": "%uEA71",
		"outlined-communication-speaker": "%uEA72",
		"outlined-communication-treatment": "%uEA73",
		"outlined-content-adddocument": "%uEA74",
		"outlined-content-agility": "%uEA75",
		"outlined-content-asleep": "%uEAE7",
		"outlined-content-bellringing": "%uEA76",
		"outlined-content-book": "%uEA77",
		"outlined-content-brightness": "%uEA78",
		"outlined-content-changeview": "%uEA79",
		"outlined-content-channel": "%uEA7A",
		"outlined-content-christmascard": "%uEA7B",
		"outlined-content-cloud": "%uEAF4",
		"outlined-content-consistency": "%uEA7C",
		"outlined-content-divulgation": "%uEA7D",
		"outlined-content-education": "%uEA7E",
		"outlined-content-exchangereports": "%uEA7F",
		"outlined-content-flower": "%uEAF5",
		"outlined-content-fragrance": "%uEAF6",
		"outlined-content-gallery": "%uEA80",
		"outlined-content-gift": "%uEA81",
		"outlined-content-global": "%uEA82",
		"outlined-content-handbag": "%uEB0E",
		"outlined-content-handcare": "%uEAE5",
		"outlined-content-handglobal": "%uEA83",
		"outlined-content-hands": "%uEA84",
		"outlined-content-health": "%uEA85",
		"outlined-content-healthy": "%uEA86",
		"outlined-content-indicator": "%uEA87",
		"outlined-content-itemlist": "%uEA88",
		"outlined-content-leafs": "%uEAF7",
		"outlined-content-lifebuoy": "%uEA89",
		"outlined-content-lock": "%uEA8A",
		"outlined-content-magic": "%uEA8B",
		"outlined-content-maintenance": "%uEAFF",
		"outlined-content-medal": "%uEA8C",
		"outlined-content-menu": "%uEA8D",
		"outlined-content-mirror": "%uEA8E",
		"outlined-content-password": "%uEA8F",
		"outlined-content-planb": "%uEA90",
		"outlined-content-productshowcase": "%uEADF",
		"outlined-content-produtivity": "%uEA91",
		"outlined-content-rainycloud": "%uEAF8",
		"outlined-content-report": "%uEA92",
		"outlined-content-saleinsight": "%uEAE8",
		"outlined-content-snow": "%uEAF9",
		"outlined-content-store": "%uEA93",
		"outlined-content-sun": "%uEAFA",
		"outlined-content-sunandcloud": "%uEAFB",
		"outlined-content-unavailable": "%uEB00",
		"outlined-content-violence": "%uEB20",
		"outlined-content-virtualmirror": "%uEB01",
		"outlined-content-wellness": "%uEA94",
		"outlined-content-wifi": "%uEA95",
		"outlined-content-world": "%uEB16",
		"outlined-default-mockup": "%uEA96",
		"outlined-finance-bag": "%uEA97",
		"outlined-finance-bank": "%uEA98",
		"outlined-finance-cards": "%uEA99",
		"outlined-finance-charging": "%uEA9A",
		"outlined-finance-creditcard": "%uEA9B",
		"outlined-finance-debit": "%uEA9C",
		"outlined-finance-discount": "%uEA9D",
		"outlined-finance-idcard": "%uEA9E",
		"outlined-finance-invoice": "%uEAFC",
		"outlined-finance-littlemachine": "%uEA9F",
		"outlined-finance-money": "%uEAA0",
		"outlined-finance-moneypaper": "%uEAA1",
		"outlined-finance-paid": "%uEAA2",
		"outlined-finance-paymentlink": "%uEAA3",
		"outlined-finance-paymentnotapproved": "%uEAFD",
		"outlined-finance-payreference": "%uEAA4",
		"outlined-finance-pix": "%uEB2C",
		"outlined-finance-promotion": "%uEAA5",
		"outlined-finance-scancard": "%uEAFE",
		"outlined-finance-shoppingcart": "%uEAA6",
		"outlined-finance-shoppingcartproduct": "%uEAA7",
		"outlined-finance-suitcase": "%uEAA8",
		"outlined-finance-tagdiscount": "%uEAA9",
		"outlined-finance-transfermoney": "%uEAAA",
		"outlined-makeup-eyebrow": "%uEB02",
		"outlined-makeup-eyelashes": "%uEB03",
		"outlined-makeup-eyeliner": "%uEB04",
		"outlined-makeup-face": "%uEB05",
		"outlined-makeup-mouth": "%uEB06",
		"outlined-media-app": "%uEAAB",
		"outlined-media-camera": "%uEAAC",
		"outlined-media-cameraunavailable": "%uEB07",
		"outlined-media-monitor": "%uEAAD",
		"outlined-media-play": "%uEAAE",
		"outlined-navigation-arrowbottom": "%uEAAF",
		"outlined-navigation-arrowleft": "%uEAB0",
		"outlined-navigation-arrowleft-alt": "%uEB23",
		"outlined-navigation-arrowright": "%uEAB1",
		"outlined-navigation-arrowright-alt": "%uEB24",
		"outlined-navigation-arrowtop": "%uEAB2",
		"outlined-navigation-close": "%uEAB3",
		"outlined-navigation-directionbottom": "%uEAB4",
		"outlined-navigation-directionleft": "%uEAB5",
		"outlined-navigation-directionleft-alt": "%uEB25",
		"outlined-navigation-directionright": "%uEAB6",
		"outlined-navigation-directionright-alt": "%uEB26",
		"outlined-navigation-directiontop": "%uEAB7",
		"outlined-navigation-exit": "%uEAB8",
		"outlined-navigation-goback": "%uEAB9",
		"outlined-navigation-gofront": "%uEABA",
		"outlined-navigation-home": "%uEABB",
		"outlined-navigation-menu": "%uEABC",
		"outlined-place-bus": "%uEABD",
		"outlined-place-forklift": "%uEABE",
		"outlined-place-gps": "%uEABF",
		"outlined-place-local": "%uEAC0",
		"outlined-place-rocket": "%uEAC1",
		"outlined-place-runningtruck": "%uEAC2",
		"outlined-place-truck": "%uEAC3",
		"outlined-place-waze": "%uEAC4",
		"outlined-product-abandonedbag": "%uEAE9",
		"outlined-product-accessories": "%uEAC5",
		"outlined-product-bagproduct": "%uEAC6",
		"outlined-product-beard": "%uEAC7",
		"outlined-product-brandsproduct": "%uEAC8",
		"outlined-product-childish": "%uEAC9",
		"outlined-product-dailycare": "%uEACA",
		"outlined-product-ekos": "%uEACB",
		"outlined-product-erlenmeyer": "%uEACC",
		"outlined-product-face": "%uEACD",
		"outlined-product-fashion": "%uEB21",
		"outlined-product-hair": "%uEACE",
		"outlined-product-lashes": "%uEB08",
		"outlined-product-liner": "%uEB09",
		"outlined-product-lipgloss": "%uEB0A",
		"outlined-product-makeup": "%uEACF",
		"outlined-product-outlet": "%uEAD0",
		"outlined-product-pencil": "%uEB0B",
		"outlined-product-perfumery": "%uEAD1",
		"outlined-product-perfumeryfeminine": "%uEAE0",
		"outlined-product-perfumerymasculine": "%uEAE1",
		"outlined-product-perfumerytbs": "%uEAE2",
		"outlined-product-powder": "%uEB0C",
		"outlined-product-primer": "%uEB0D",
		"outlined-product-promotionproduct": "%uEAD2",
		"outlined-product-relatedproducts": "%uEAEA",
		"outlined-product-repurchase": "%uEAEB",
		"outlined-product-scent": "%uEAD3",
		"outlined-product-vegan": "%uEAD4",
		"outlined-social-addcontact": "%uEAD5",
		"outlined-social-birthday": "%uEAD6",
		"outlined-social-collaborate": "%uEAD7",
		"outlined-social-contact": "%uEAD8",
		"outlined-social-digitalconsultant": "%uEAD9",
		"outlined-social-groupofpeople": "%uEADA",
		"outlined-social-management": "%uEAE3",
		"outlined-social-myprofile": "%uEADB",
		"outlined-social-network": "%uEADC",
		"outlined-social-person": "%uEADD"
	};

	const iconNames = Object.keys(icons);

	exports.iconNames = iconNames;
	exports.icons = icons;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.js.map
